var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentOnTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 190,
    viewBox: "0 0 237 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.86 106L2 47.236L104.386 2L235 47.236L143.86 106Z",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.674 63.2755L92.25 51.8089C89.8422 50.8705 89.6683 47.5298 91.9657 46.3466L110.067 37.0238C112.052 36.0014 114.374 35.8552 116.472 36.6204L145.478 47.2027C147.866 48.0736 148.157 51.3324 145.962 52.6125L128.609 62.7322C126.501 63.9615 123.947 64.1615 121.674 63.2755Z",
    fill: "#35C7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144 106V188",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235 47V129",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 48V130",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130 182L130 117.199L16 69L16 136.479",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157 182L157 117.663L223 73L223 139.995",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75V129",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211 81V135",
    stroke: "#ACB3B8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOnTable);
export default __webpack_public_path__ + "static/media/document-on-table.06f95d84d762a50967d4f48db9ed3da9.svg";
export { ForwardRef as ReactComponent };